module.exports = __webpack_public_path__ + "static/media/mars_rotation.f45177b6.mp4";